import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const assistantFeedbackSubmittedV1Schema = eventEnvelopeSchema.extend({
  userId: z.string().min(1).max(256),
  entryId: z.string().min(1).max(256),
  feedback: z.enum(['up', 'down']),
  provider: z.string().min(1).max(128).optional(),
  runId: z.string().min(1).max(256).optional(),
  sessionReplayId: z.string().min(1).max(256).optional(),
  source: z.string().min(1).max(128),
  threadId: z.string().min(1).max(256),
});

export type AssistantFeedbackSubmittedV1 = z.infer<
  typeof assistantFeedbackSubmittedV1Schema
>;

export const ASSISTANT_FEEDBACK_SUBMITTED_V1_DETAIL_TYPE =
  'assistant.feedback-submitted.v1' as const;
